import { cB as r, c as e, cM as o, cNotM as t } from "../../../_utils/cssr/index.js";
const n = `
 background: var(--n-item-color-hover);
 color: var(--n-item-text-color-hover);
 border: var(--n-item-border-hover);
`, i = [o("button", `
 background: var(--n-button-color-hover);
 border: var(--n-button-border-hover);
 color: var(--n-button-icon-color-hover);
 `)], c = r("pagination", `
 display: flex;
 vertical-align: middle;
 font-size: var(--n-item-font-size);
 flex-wrap: nowrap;
`, [r("pagination-prefix", `
 display: flex;
 align-items: center;
 margin: var(--n-prefix-margin);
 `), r("pagination-suffix", `
 display: flex;
 align-items: center;
 margin: var(--n-suffix-margin);
 `), e("> *:not(:first-child)", `
 margin: var(--n-item-margin);
 `), r("select", `
 width: var(--n-select-width);
 `), e("&.transition-disabled", [r("pagination-item", "transition: none!important;")]), r("pagination-quick-jumper", `
 white-space: nowrap;
 display: flex;
 color: var(--n-jumper-text-color);
 transition: color .3s var(--n-bezier);
 align-items: center;
 font-size: var(--n-jumper-font-size);
 `, [r("input", `
 margin: var(--n-input-margin);
 width: var(--n-input-width);
 `)]), r("pagination-item", `
 position: relative;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 display: flex;
 align-items: center;
 justify-content: center;
 box-sizing: border-box;
 min-width: var(--n-item-size);
 height: var(--n-item-size);
 padding: var(--n-item-padding);
 background-color: var(--n-item-color);
 color: var(--n-item-text-color);
 border-radius: var(--n-item-border-radius);
 border: var(--n-item-border);
 fill: var(--n-button-icon-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 fill .3s var(--n-bezier);
 `, [o("button", `
 background: var(--n-button-color);
 color: var(--n-button-icon-color);
 border: var(--n-button-border);
 padding: 0;
 `, [r("base-icon", `
 font-size: var(--n-button-icon-size);
 `)]), t("disabled", [o("hover", n, i), e("&:hover", n, i), e("&:active", `
 background: var(--n-item-color-pressed);
 color: var(--n-item-text-color-pressed);
 border: var(--n-item-border-pressed);
 `, [o("button", `
 background: var(--n-button-color-pressed);
 border: var(--n-button-border-pressed);
 color: var(--n-button-icon-color-pressed);
 `)]), o("active", `
 background: var(--n-item-color-active);
 color: var(--n-item-text-color-active);
 border: var(--n-item-border-active);
 `, [e("&:hover", `
 background: var(--n-item-color-active-hover);
 `)])]), o("disabled", `
 cursor: not-allowed;
 color: var(--n-item-text-color-disabled);
 `, [o("active, button", `
 background-color: var(--n-item-color-disabled);
 border: var(--n-item-border-disabled);
 `)])]), o("disabled", `
 cursor: not-allowed;
 `, [r("pagination-quick-jumper", `
 color: var(--n-jumper-text-color-disabled);
 `)]), o("simple", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 `, [r("pagination-quick-jumper", [r("input", `
 margin: 0;
 `)])])]);
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/pagination/src/styles/index.cssr.js
// module id = 1678
// module chunks = 41